import { RealEstate } from "@onpreo/database/src/definitions/real-estate";

export type PropertyState = {
    type: string;
};

export const initialPropertyState = {
    type: ""
};
